module.exports = __webpack_public_path__ + "static/media/ic_proyectos_fluvial_pin.8b88b36c.svg";